import React from 'react';
interface MobileFrameProps {
  children: React.ReactNode;
}
function StatusBar() {
  return <div className="absolute top-0 left-0 right-0 h-11 bg-[#0F4C3A] flex items-center justify-between px-7 z-50" data-id="element-18">
      <span className="text-white text-[15px] font-semibold tracking-tight" data-id="element-19">
        9:41
      </span>

      <div className="flex items-center gap-1.5" data-id="element-20">
        {/* Cellular signal */}
        <svg width="17" height="11" viewBox="0 0 17 11" fill="none" aria-hidden="true" data-id="element-21">
          <rect x="0" y="7" width="3" height="4" rx="1" fill="white" data-id="element-22" />
          <rect x="4.5" y="5" width="3" height="6" rx="1" fill="white" data-id="element-23" />
          <rect x="9" y="2.5" width="3" height="8.5" rx="1" fill="white" data-id="element-24" />
          <rect x="13.5" y="0" width="3" height="11" rx="1" fill="white" data-id="element-25" />
        </svg>
        {/* Wifi */}
        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" aria-hidden="true" data-id="element-26">
          <path d="M8 2.2c2.5 0 4.8.95 6.5 2.55l-1.2 1.25A7.7 7.7 0 0 0 8 3.95 7.7 7.7 0 0 0 2.7 6L1.5 4.75A9.45 9.45 0 0 1 8 2.2Z" fill="white" data-id="element-27" />
          <path d="M8 5.6c1.55 0 2.95.6 4 1.6l-1.25 1.3A3.85 3.85 0 0 0 8 7.35c-1.05 0-2 .42-2.75 1.15L4 7.2A5.75 5.75 0 0 1 8 5.6Z" fill="white" data-id="element-28" />
          <circle cx="8" cy="9.6" r="1.3" fill="white" data-id="element-29" />
        </svg>
        {/* Battery */}
        <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-30">
          <div className="relative w-[24px] h-[12px] rounded-[3px] border border-white/60 p-[1.5px]" data-id="element-31">
            <div className="h-full w-[80%] bg-white rounded-[1.5px]" data-id="element-32" />
          </div>
          <div className="w-[1.5px] h-[4px] bg-white/60 rounded-r" data-id="element-33" />
        </div>
      </div>

      {/* Dynamic island */}
      <div className="absolute left-1/2 -translate-x-1/2 top-2 w-[92px] h-[26px] bg-black rounded-full" data-id="element-34" />
    </div>;
}
export function MobileFrame({
  children
}: MobileFrameProps) {
  return <div className="relative w-[378px] h-[816px] rounded-[3.2rem] bg-black p-[3px] shadow-2xl" data-id="element-35">
      {/* Inner device */}
      <div className="relative w-full h-full rounded-[3rem] overflow-hidden bg-[#F7F8F7] ring-1 ring-black/5" data-id="element-36">
        <StatusBar data-id="element-37" />

        {/* Screen Content */}
        <div className="h-full pt-11 pb-2 bg-[#F7F8F7] flex flex-col relative z-0" data-id="element-38">
          {children}
        </div>

        {/* Home Indicator */}
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-[134px] h-[5px] bg-gray-800/80 rounded-full z-50 pointer-events-none" data-id="element-39" />
      </div>
    </div>;
}